import { Link } from 'react-router-dom'

/** Wordmark + link home (SVGs in `webapp/public`). */
export function EmmaBrandLink() {
  return (
    <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
      <Link to="/" style={{ display: 'inline-block', lineHeight: 0, textDecoration: 'none' }}>
        <img src="/emma-logo.svg" alt="Emma" style={{ height: 64, width: 'auto', maxWidth: '100%' }} />
      </Link>
    </div>
  )
}
